export default __webpack_public_path__ + "static/media/prize_1.min.facbafd2.png";